import { render, staticRenderFns } from "./PromptTemplateForm.vue?vue&type=template&id=e90b3e20&scoped=true"
import script from "./PromptTemplateForm.vue?vue&type=script&lang=js"
export * from "./PromptTemplateForm.vue?vue&type=script&lang=js"
import style0 from "./PromptTemplateForm.vue?vue&type=style&index=0&id=e90b3e20&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90b3e20",
  null
  
)

export default component.exports